// extracted by mini-css-extract-plugin
export default {"header":"main_header__TY5EY","content":"main_content__FJY6b"};